import { AccessPermission, UserRole } from './user.type'

export const RoleOptions = [
  {
    value: UserRole.ADMIN,
    label: 'Admin',
  },
  {
    value: UserRole.LEADER,
    label: 'QA Lead',
  },
  {
    value: UserRole.MEMBER,
    label: 'QA Member',
  },
  {
    value: UserRole.AGENT,
    label: 'Agent',
  },
]

export const RoleMaps = {
  [UserRole.ADMIN]: {
    label: 'Admin',
    description:
      'Has access to all modules. Can change roles and view permissions of lower ranks.',
    style: {
      color: 'var(--accent-blue)',
      backgroundColor: 'var(--accent-light-blue)',
    },
  },
  [UserRole.LEADER]: {
    label: 'QA Lead',
    description: 'Has limited access to modules and settings related to team management.',
    style: {
      color: 'var(--accent-orange)',
      backgroundColor: 'var(--accent-light-orange)',
    },
  },
  [UserRole.MEMBER]: {
    label: 'QA Member',
    description: 'Has limited access to modules.',
    style: {
      color: 'var(--grey-400)',
      backgroundColor: 'var(--grey-50)',
    },
  },
  [UserRole.AGENT]: {
    label: 'Agent',
    description: '',
    style: {},
  },
}

export const AccessMaps = {
  [AccessPermission.FULL_ACCESS]: {
    color: 'var(--accent-blue)',
    backgroundColor: 'var(--accent-light-blue)',
    padding: '2px 12px',
  },
  [AccessPermission.LIMITED_ACCESS]: {
    color: 'var(--grey-400)',
    backgroundColor: 'var(--grey-50)',
    padding: '2px 8px',
  },
}
